<template>
  <div
    class="absolute -top-1 z-1 hidden items-center space-x-1-5 rounded-lg border border-divider bg-white p-2 shadow group-hover:flex"
    :class="isPinned ? 'right-8' : 'right-2'"
  >
    <button
      v-for="action in actions"
      :key="action.name"
      :data-cy="`action-${action.name}`"
      @click="action.click"
    >
      <icon-base
        v-if="action.icon"
        :icon="action.icon"
        :class="action.class"
        :view-box="action.viewBox ?? '0 0 16 16'"
        v-tooltip="action.tooltip"
      />
      <component
        :is="action.component"
        v-else
        :class="action.class"
        v-bind="action.props"
        v-tooltip="action.tooltip"
      />
    </button>
  </div>
</template>
<script setup lang="ts">
import IconBase from "@/components/ui/IconBase.vue";

import type { ActivityAction } from "@/models/dealActivity";

const { actions, isPinned = false } = defineProps<{
  actions: ActivityAction[];
  isPinned?: boolean;
}>();
</script>
